// Import model
import { TaxLiability } from '../models/TaxLiability';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for TaxLiability - handles JSON serialization and deserialization with type validation
 */
export class TaxLiabilitySerializer {
  /**
   * Deserializes a JSON string into a TaxLiability instance
   */
  static deserialize(json: string): TaxLiability {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a TaxLiability instance
   */
  static fromObject(obj: any): TaxLiability {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to TaxLiability');
    }


    const instance: TaxLiability = {
      amount: obj['amount'] as number | undefined,
      category: obj['category'] as string | undefined,
      description: obj['description'] as string | undefined,
      name: obj['name'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of TaxLiability instances
   */
  static deserializeArray(json: string): TaxLiability[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a TaxLiability instance to a JSON string
   */
  static serialize(instance: TaxLiability): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a TaxLiability instance to a plain object
   */
  static toObject(instance: TaxLiability): any {
    return {
      'amount': instance.amount,
      'category': instance.category,
      'description': instance.description,
      'name': instance.name,
    };
  }

  /**
   * Serializes an array of TaxLiability instances to a JSON string
   */
  static serializeArray(instances: TaxLiability[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
